/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxTabsComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxtabs';

/**
 * Tabs
 */

export class NgcTabsComponent extends ControlComponent {
     animationType: any;
     autoHeight: any;
     closeButtonSize: any;
     collapsible: any;
     contentTransitionDuration: any;
     disabled: any;
     enabledHover: any;
     enableScrollAnimation: any;
     initTabContent: any;
     keyboardNavigation: any;
     next: any;
     previous: any;
     position: any;
     reorder: any;
     rtl: any;
     scrollAnimationDuration: any;
     selectedItem: any;
     selectionTracker: any;
     scrollable: any;
     scrollPosition: any;
     scrollStep: any;
     showCloseButtons: any;
     toggleMode: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-tabs',
    template: `<jqxTabs
                [animationType] = "animationType"
                [autoHeight] = "autoHeight"
                [closeButtonSize] = "closeButtonSize"
                [collapsible] = "collapsible"
                [contentTransitionDuration] = "contentTransitionDuration"
                [disabled] = "disabled"
                [enabledHover] = "enabledHover"
                [enableScrollAnimation] = "enableScrollAnimation"
                [initTabContent] = "initTabContent"
                [keyboardNavigation] = "keyboardNavigation"
                [next] = "next"
                [previous] = "previous"
                [position] = "position"
                [reorder] = "reorder"
                [rtl] = "rtl"
                [scrollAnimationDuration] = "scrollAnimationDuration"
                [selectedItem] = "selectedItem"
                [selectionTracker] = "selectionTracker"
                [scrollable] = "scrollable"
                [scrollPosition] = "scrollPosition"
                [scrollStep] = "scrollStep"
                [showCloseButtons] = "showCloseButtons"
                [toggleMode] = "toggleMode"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxTabs>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animationType': [{ type: Input, args: ['animationType', ] },],
'autoHeight': [{ type: Input, args: ['autoHeight', ] },],
'closeButtonSize': [{ type: Input, args: ['closeButtonSize', ] },],
'collapsible': [{ type: Input, args: ['collapsible', ] },],
'contentTransitionDuration': [{ type: Input, args: ['contentTransitionDuration', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'enabledHover': [{ type: Input, args: ['enabledHover', ] },],
'enableScrollAnimation': [{ type: Input, args: ['enableScrollAnimation', ] },],
'initTabContent': [{ type: Input, args: ['initTabContent', ] },],
'keyboardNavigation': [{ type: Input, args: ['keyboardNavigation', ] },],
'next': [{ type: Input, args: ['next', ] },],
'previous': [{ type: Input, args: ['previous', ] },],
'position': [{ type: Input, args: ['position', ] },],
'reorder': [{ type: Input, args: ['reorder', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'scrollAnimationDuration': [{ type: Input, args: ['scrollAnimationDuration', ] },],
'selectedItem': [{ type: Input, args: ['selectedItem', ] },],
'selectionTracker': [{ type: Input, args: ['selectionTracker', ] },],
'scrollable': [{ type: Input, args: ['scrollable', ] },],
'scrollPosition': [{ type: Input, args: ['scrollPosition', ] },],
'scrollStep': [{ type: Input, args: ['scrollStep', ] },],
'showCloseButtons': [{ type: Input, args: ['showCloseButtons', ] },],
'toggleMode': [{ type: Input, args: ['toggleMode', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Tabs Module
 */

export class NgcTabsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcTabsComponent],
    declarations: [NgcTabsComponent, jqxTabsComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
